import type { MapViewModules, State } from "../types";
import { extractAvailableFilters } from "./filter";

export const initialState: Partial<State> = {
  isPreviewCardEnabled: false,
  prevSelectedItems: [],
  selectedItems: [],
  highlightedItem: null,
  prevHighlightedItem: null,
  clusterPointsOfInterest: [],
  shouldTriggerLoadMore: false,
  showErrorMessage: false,
  isLeftRailItemHover: false,
  isLoadingMoreItems: false,
  isEmptyMapTrackerVisible: false,
  isAutoLoadTrackerVisible: false,
  watchListItems: [],
};

export function stateFromModel(model?: MapViewModules): Partial<State> {
  const {
    pointsOfInterest,
    help,
    survey,
    surveyButton,
    resetMapviewButton,
    mapMessage,
    mapAccessibilityTexts,
    locateMe,
    itemCardNavigationAction = {},
    sellerListingCountLabel = {},
    itemCardCloseAction = {},
    walkingDistance,
    meta,
    banners,
    controlButtons,
  } = model?.mapview ?? {};
  const { postalCodePillData, watchlistPillData, itemConditionPillData, pricePillData } = model?.mapDataControls ?? {};

  const finalPointsOfInterest = pointsOfInterest ?? [];
  const availableFilters = extractAvailableFilters(finalPointsOfInterest);
  return {
    isLoading: !pointsOfInterest,
    help,
    survey,
    surveyButton,
    pointsOfInterest: finalPointsOfInterest,
    leftRailItems: finalPointsOfInterest,
    resetMapviewButton,
    mapMessage,
    mapAccessibilityTexts,
    locateMe,
    itemCardControls: {
      itemCardNavigationAction: itemCardNavigationAction,
      sellerListingCountLabel: sellerListingCountLabel,
      itemCardCloseAction: itemCardCloseAction,
    },
    walkingDistance,
    postalCodePillData,
    watchlistPillData,
    itemConditionPillData,
    pricePillData,
    meta,
    availableFilters,
    filteredPointsOfInterest: [],
    showErrorMessage: Boolean(pointsOfInterest?.length === 0),
    banners,
    controlButtons,
  };
}
